import PublicNavbar from '../components/publico/PublicNavbar';
// src/pages/ReservaSearchPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { canchaService } from "../services/canchaService";
import { reservaService } from "../services/reservaService";

const tipos = [
  { value: "", label: "Todos" },
  { value: "futbol", label: "Fútbol" },
  { value: "tenis", label: "Tenis" },
  { value: "basquet", label: "Básquet" },
  { value: "voley", label: "Vóley" },
];

export default function ReservaSearchPage() {
  // --- Mercado Pago handler (usando reservaService como en EstablishmentDetail) ---
  async function handleMercadoPago(e) {
    e.preventDefault();
    try {
      const horaInicio = reservaData.filtros.horaExacta;
      const duracion = Number(reservaData.filtros.duracion || 1);
      const horaFin = calcularHoraFin(horaInicio, duracion);

      const payload = {
        cancha_id: reservaData.cancha.id,
        fecha: reservaData.filtros.fecha,
        hora_inicio: horaInicio,
        hora_fin: horaFin,
        observaciones: "",
      };

      const resp = await reservaService.crearPreferenciaPago(payload);
      if (resp.success && resp.mercadopago_url) {
        window.location.href = resp.mercadopago_url;
      } else {
        alert(resp.message || "Error al iniciar pago");
      }
    } catch (err) {
      alert(
        err?.response?.data?.message ||
        err?.userMessage ||
        "Error al conectar con Mercado Pago"
      );
    }
  }

  function calcularHoraFin(horaInicio, duracion) {
    const [h, m] = horaInicio.split(':').map(Number);
    const date = new Date(0, 0, 0, h, m);
    date.setHours(date.getHours() + Number(duracion));
    return date.toTimeString().slice(0, 5);
  }
  const { isAuthenticated, login, register } = useAuth();

  // Modales / auth
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [authTab, setAuthTab] = useState("login"); // 'login' | 'register'
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState("");
  const [showReservaModal, setShowReservaModal] = useState(false);
  const [reservaData, setReservaData] = useState(null);
  // Modal de gracias
  const [showGraciasModal, setShowGraciasModal] = useState(false);

  // Filtros
  const [tipo, setTipo] = useState("");
  const [fecha, setFecha] = useState("");
  const [horaExacta, setHoraExacta] = useState("");
  const [duracion, setDuracion] = useState(1);

  // (si quieres volver a usar rango, reintroduce estos estados y el query)
  const [horaDesde, setHoraDesde] = useState("");
  const [horaHasta, setHoraHasta] = useState("");

  // Resultados
  const [page, setPage] = useState(1);
  const [perPage] = useState(12);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState({ data: [], meta: {} });

  // Querystring
  const qs = useMemo(() => {
    const p = new URLSearchParams();
    if (tipo) p.set("tipo", tipo);
    if (fecha) p.set("fecha", fecha);

    // Disponibilidad solo si hay fecha + hora exacta + duración
    if (horaExacta && duracion && fecha) {
      p.set("hora_inicio", horaExacta);
      p.set("duracion", duracion);
      p.set("solo_disponibles", "1");
    }

    p.set("page", page);
    p.set("per_page", perPage);
    return p.toString();
  }, [tipo, fecha, horaExacta, duracion, page, perPage]);

  // Fetch
  async function fetchCanchas() {
    setLoading(true);
    try {
      const params = Object.fromEntries(new URLSearchParams(qs));
      const resp = await canchaService.buscarPublicas(params);
      setResult({ data: resp.data || [], meta: resp.meta || {} });
    } catch (e) {
      console.error(e);
      setResult({ data: [], meta: {} });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCanchas();
  }, [qs]); // eslint-disable-line react-hooks/exhaustive-deps

  // Detectar si la URL es /gracias o contiene /gracias
  useEffect(() => {
    if (window.location.pathname.endsWith('/gracias')) {
      setShowGraciasModal(true);
      // Opcional: limpiar la URL para evitar que el modal se muestre siempre si el usuario refresca
      window.history.replaceState({}, document.title, '/');
    }
  }, []);

  return (
    <>
      <PublicNavbar />
      <div className="relative min-h-screen pt-28 pb-16 overflow-hidden font-sans">
      <div className="relative z-10 max-w-6xl mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-extrabold text-emerald-700 text-center drop-shadow-lg tracking-tight">
          Encuentra y <span className="text-blue-600">reserva tu cancha</span>
        </h1>

        {/* FILTROS */}
        <div className="mt-10 rounded-3xl bg-white/80 backdrop-blur-lg p-8 shadow-2xl border border-emerald-100">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div>
              <label className="block text-base font-bold text-emerald-700">Deporte</label>
              <select
                className="mt-2 w-full rounded-full border-2 border-emerald-200 px-4 py-2 bg-white focus:ring-2 focus:ring-emerald-400"
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
              >
                {tipos.map((t) => (
                  <option key={t.value} value={t.value}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-base font-bold text-emerald-700">Fecha</label>
              <input
                type="date"
                className="mt-2 w-full rounded-full border-2 border-emerald-200 px-4 py-2 bg-white focus:ring-2 focus:ring-emerald-400"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-base font-bold text-emerald-700">Hora exacta</label>
              <select
                className="mt-2 w-full rounded-full border-2 border-emerald-200 px-4 py-2 bg-white focus:ring-2 focus:ring-emerald-400"
                value={horaExacta}
                onChange={(e) => setHoraExacta(e.target.value)}
              >
                <option value="">--</option>
                {Array.from({ length: 48 }, (_, i) => {
                  const h = String(Math.floor(i / 2)).padStart(2, "0");
                  const m = i % 2 === 0 ? "00" : "30";
                  const v = `${h}:${m}`;
                  return (
                    <option key={v} value={v}>
                      {v}
                    </option>
                  );
                })}
              </select>
            </div>

            <div>
              <label className="block text-base font-bold text-emerald-700">Duración (horas)</label>
              <select
                className="mt-2 w-full rounded-full border-2 border-emerald-200 px-4 py-2 bg-white focus:ring-2 focus:ring-emerald-400"
                value={duracion}
                onChange={(e) => setDuracion(Number(e.target.value))}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8].map((h) => (
                  <option key={h} value={h}>
                    {h}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => {
                setPage(1);
                fetchCanchas();
              }}
              className="rounded-full bg-gradient-to-r from-emerald-500 to-blue-500 text-white px-8 py-3 font-bold shadow-lg hover:scale-105 hover:from-emerald-600 hover:to-blue-600 transition-all text-lg"
            >
              Buscar
            </button>
            <button
              onClick={() => {
                setTipo("");
                setFecha("");
                setHoraExacta("");
                setDuracion(1);
                setHoraDesde("");
                setHoraHasta("");
                setPage(1);
              }}
              className="rounded-full border-2 border-emerald-400 px-8 py-3 font-bold text-emerald-700 bg-white shadow hover:bg-emerald-50 transition-all text-lg"
            >
              Limpiar
            </button>
          </div>
        </div>

        {/* RESULTADOS estilo comparador */}
        <div className="mt-14">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-16 text-slate-600">
              <svg className="animate-spin mb-4" width="48" height="48" viewBox="0 0 50 50">
                <circle className="opacity-20" cx="25" cy="25" r="20" stroke="#10B981" strokeWidth="6" fill="none" />
                <circle className="opacity-80" cx="25" cy="25" r="20" stroke="#10B981" strokeWidth="6" fill="none" strokeDasharray="100" strokeDashoffset="60" />
              </svg>
              <div className="text-lg font-semibold">Buscando establecimientos disponibles…</div>
              <div className="text-sm text-slate-400 mt-1">Por favor espera un momento.</div>
            </div>
          ) : result.data.length === 0 ? (
            <div className="text-center text-slate-600">No se encontraron canchas.</div>
          ) : (
            <>
              <div className="mb-4 text-slate-600">
                <span className="font-semibold">{result.meta?.total ?? result.data.length}</span>{" "}
                opciones disponibles
              </div>

              {/* Cabecera */}
              <div className="hidden md:grid grid-cols-12 bg-teal-500 text-white rounded-t-xl text-sm font-semibold">
                <div className="col-span-4 py-3 px-4 rounded-tl-xl">Producto</div>
                <div className="col-span-2 py-3 px-4 text-center">Valor/Hora</div>
                <div className="col-span-2 py-3 px-4 text-center">Tipo</div>
                <div className="col-span-2 py-3 px-4 text-center">Disponibilidad</div>
                <div className="col-span-2 py-3 px-4 text-center rounded-tr-xl">Más Info</div>
              </div>

              {/* Filas */}
              <div className="divide-y rounded-b-xl overflow-hidden bg-white shadow">
                {[...result.data]
                  .sort((a, b) => (a.precio_por_hora ?? 0) - (b.precio_por_hora ?? 0))
                  .map((c, idx) => {
                    const precio = (c.precio_por_hora ?? 0).toFixed(2);
                    const cardImg =
                      (Array.isArray(c.imagenes_establecimiento) && c.imagenes_establecimiento[0]) ||
                      c.foto_establecimiento ||
                      (Array.isArray(c.imagenes) && c.imagenes[0]) ||
                      c.primera_imagen ||
                      "";

                    return (
                      <div
                        key={c.id}
                        className={`grid grid-cols-1 md:grid-cols-12 items-center gap-4 md:gap-0 p-4 ${
                          idx === 0 ? "bg-teal-50" : "bg-white"
                        }`}
                      >
                        {/* Producto */}
                        <div className="md:col-span-4 flex items-center gap-4">
                          <div className="w-16 h-16 rounded-lg bg-gray-100 overflow-hidden shrink-0 hidden md:block">
                            {cardImg ? (
                              <img src={cardImg} alt="" className="w-full h-full object-cover" />
                            ) : (
                              <div className="w-full h-full grid place-items-center text-gray-400 text-xs">
                                Sin imagen
                              </div>
                            )}
                          </div>
                          <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                              <div className="text-slate-900 font-bold leading-tight">{c.nombre_cancha}</div>
                              {idx === 0 && (
                                <span className="inline-flex items-center gap-1 bg-amber-400 text-amber-900 text-[11px] font-bold px-2.5 py-0.5 rounded-full shadow-sm border border-amber-300">
                                  ⭐ DESTACADO
                                </span>
                              )}
                            </div>
                            <div className="text-slate-600 text-sm">{c.nombre_establecimiento}</div>
                            <div className="text-slate-500 text-xs md:text-[11px]">
                              {c.direccion_establecimiento}
                            </div>
                          </div>
                        </div>

                        {/* Valor/Hora */}
                        <div className="md:col-span-2 text-center">
                          <div className="text-slate-900 font-extrabold text-lg">S/ {precio}</div>
                          <div className="text-slate-500 text-xs">por hora</div>
                        </div>

                        {/* Tipo */}
                        <div className="md:col-span-2 text-center">
                          <div className="text-slate-800 font-semibold capitalize">{c.tipo}</div>
                          <div className="text-slate-500 text-xs">Cancha</div>
                        </div>

                        {/* Disponibilidad */}
                        <div className="md:col-span-2 text-center">
                          <div className="text-emerald-700 font-semibold">Consultar</div>
                          <div className="text-slate-500 text-xs">según fecha/horario</div>
                        </div>

                        {/* CTA */}
                        <div className="md:col-span-2 flex md:justify-center">
                          <button
                            className="inline-flex items-center justify-center rounded-full bg-rose-500 text-white px-6 py-2.5 font-semibold shadow-md hover:shadow-lg hover:opacity-95 transition"
                            onClick={() => {
                              const payload = {
                                cancha: c,
                                filtros: { tipo, fecha, horaExacta, duracion },
                              };
                              if (!isAuthenticated) {
                                setReservaData(payload);
                                setShowLoginModal(true);
                              } else {
                                setReservaData(payload);
                                setShowReservaModal(true);
                              }
                            }}
                          >
                            Reservar
                          </button>
                        </div>

                        {/* Mobile image */}
                        <div className="md:hidden -mt-2">
                          <div className="w-full h-28 rounded-lg overflow-hidden bg-gray-100">
                            {cardImg ? (
                              <img src={cardImg} alt="" className="w-full h-full object-cover" />
                            ) : (
                              <div className="w-full h-full grid place-items-center text-gray-400 text-xs">
                                Sin imagen
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </>
          )}

          {/* Paginación */}
          {result.meta?.last_page > 1 && (
            <div className="mt-8 flex justify-center gap-3">
              <button
                disabled={page <= 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                className="rounded-full border px-4 py-2 disabled:opacity-50"
              >
                Anterior
              </button>
              <span className="px-2 py-2">
                Página {page} / {result.meta.last_page}
              </span>
              <button
                disabled={page >= result.meta.last_page}
                onClick={() => setPage((p) => p + 1)}
                className="rounded-full border px-4 py-2 disabled:opacity-50"
              >
                Siguiente
              </button>
            </div>
          )}
        </div>
      {/* MODAL GRACIAS */}
      {showGraciasModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full relative text-center">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl"
              onClick={() => {
                setShowGraciasModal(false);
                setTipo("");
                setFecha("");
                setHoraExacta("");
                setDuracion(1);
                setHoraDesde("");
                setHoraHasta("");
                setPage(1);
                fetchCanchas();
              }}
              aria-label="Cerrar"
            >
              &times;
            </button>
            <div className="flex flex-col items-center gap-4">
              <svg width="60" height="60" fill="none" viewBox="0 0 60 60">
                <circle cx="30" cy="30" r="30" fill="#10B981"/>
                <path d="M18 32l8 8 16-16" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <h2 className="text-2xl font-bold text-emerald-700">¡Gracias por tu reserva!</h2>
              <p className="text-slate-600">Tu pago fue procesado correctamente.<br/>Pronto recibirás la confirmación en tu correo.</p>
              <button
                className="mt-4 rounded-full bg-emerald-600 text-white px-6 py-2 font-bold"
                onClick={() => {
                  setShowGraciasModal(false);
                  setTipo("");
                  setFecha("");
                  setHoraExacta("");
                  setDuracion(1);
                  setHoraDesde("");
                  setHoraHasta("");
                  setPage(1);
                  fetchCanchas();
                }}
              >
                Volver al inicio
              </button>
            </div>
          </div>
        </div>
      )}
      </div>

      {/* MODAL LOGIN / REGISTRO */}
      {showLoginModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
              onClick={() => setShowLoginModal(false)}
            >
              &times;
            </button>

            <div className="flex justify-center mb-4">
              <button
                className={`px-4 py-2 font-bold rounded-l-full ${
                  authTab === "login" ? "bg-emerald-500 text-white" : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => {
                  setAuthTab("login");
                  setAuthError("");
                }}
              >
                Iniciar sesión
              </button>
              <button
                className={`px-4 py-2 font-bold rounded-r-full ${
                  authTab === "register" ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => {
                  setAuthTab("register");
                  setAuthError("");
                }}
              >
                Registrarse
              </button>
            </div>

            {authTab === "login" && (
              <LoginForm
                loading={authLoading}
                error={authError}
                onLogin={async (credentials) => {
                  setAuthLoading(true);
                  setAuthError("");
                  try {
                    await login(credentials);
                    setShowLoginModal(false);
                    setShowReservaModal(true);
                  } catch (e) {
                    setAuthError(e?.response?.data?.message || "Error al iniciar sesión");
                  } finally {
                    setAuthLoading(false);
                  }
                }}
              />
            )}

            {authTab === "register" && (
              <RegisterForm
                loading={authLoading}
                error={authError}
                onRegister={async (userData) => {
                  setAuthLoading(true);
                  setAuthError("");
                  try {
                    await register(userData);
                    setShowLoginModal(false);
                    setShowReservaModal(true);
                  } catch (e) {
                    setAuthError(e?.response?.data?.message || "Error al registrarse");
                  } finally {
                    setAuthLoading(false);
                  }
                }}
              />
            )}
          </div>
        </div>
      )}

      {/* MODAL RESERVA */}
      {showReservaModal && reservaData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
              onClick={() => setShowReservaModal(false)}
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-center">Reservar cancha</h2>

            <div className="mb-4">
              <div className="font-semibold text-emerald-700">{reservaData.cancha.nombre_cancha}</div>
              <div className="text-sm text-gray-500">{reservaData.cancha.nombre_establecimiento}</div>
              <div className="text-xs text-gray-400">{reservaData.cancha.direccion_establecimiento}</div>
            </div>

            {/* Formulario de confirmación */}
            <form className="flex flex-col gap-4" onSubmit={handleMercadoPago}>
              <div>
                <label className="block text-sm font-bold text-emerald-700">Fecha</label>
                <input
                  type="text"
                  className="mt-1 w-full rounded border px-3 py-2"
                  value={reservaData.filtros.fecha || ""}
                  readOnly
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-emerald-700">Hora</label>
                <input
                  type="text"
                  className="mt-1 w-full rounded border px-3 py-2"
                  value={reservaData.filtros.horaExacta || ""}
                  readOnly
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-emerald-700">Duración (horas)</label>
                <input
                  type="text"
                  className="mt-1 w-full rounded border px-3 py-2"
                  value={reservaData.filtros.duracion || 1}
                  readOnly
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-emerald-700">Precio total</label>
                <input
                  type="text"
                  className="mt-1 w-full rounded border px-3 py-2 bg-gray-100 font-bold"
                  value={`S/ ${(Number(reservaData.cancha.precio_por_hora || 0) * Number(reservaData.filtros.duracion || 1)).toFixed(2)}`}
                  readOnly
                />
              </div>

              <button type="submit" className="rounded-full bg-emerald-600 text-white px-6 py-2 font-bold mt-2">
                Pagar con Mercado Pago
              </button>
            </form>
          </div>
        </div>
      )}
      </div>
    </>
  );
}

/* ---------- Subcomponentes ---------- */

function LoginForm({ onLogin, loading, error }) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        onLogin({ email, password });
      }}
    >
      <div>
        <label className="block text-sm font-bold text-emerald-700">Email</label>
        <input
          type="email"
          className="mt-1 w-full rounded border px-3 py-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-bold text-emerald-700">Contraseña</label>
        <input
          type="password"
          className="mt-1 w-full rounded border px-3 py-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      {error && <div className="text-red-500 text-sm text-center">{error}</div>}
      <button
        type="submit"
        className="rounded-full bg-emerald-600 text-white px-6 py-2 font-bold mt-2 disabled:opacity-60"
        disabled={loading}
      >
        {loading ? "Ingresando..." : "Ingresar"}
      </button>
    </form>
  );
}

function RegisterForm({ onRegister, loading, error }) {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [password_confirmation, setPasswordConfirmation] = React.useState("");

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        onRegister({ name, email, password, password_confirmation });
      }}
    >
      <div>
        <label className="block text-sm font-bold text-blue-700">Nombre</label>
        <input
          type="text"
          className="mt-1 w-full rounded border px-3 py-2"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-bold text-blue-700">Email</label>
        <input
          type="email"
          className="mt-1 w-full rounded border px-3 py-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-bold text-blue-700">Contraseña</label>
        <input
          type="password"
          className="mt-1 w-full rounded border px-3 py-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-bold text-blue-700">Confirmar contraseña</label>
        <input
          type="password"
          className="mt-1 w-full rounded border px-3 py-2"
          value={password_confirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          required
        />
      </div>
      {error && <div className="text-red-500 text-sm text-center">{error}</div>}
      <button
        type="submit"
        className="rounded-full bg-blue-600 text-white px-6 py-2 font-bold mt-2 disabled:opacity-60"
        disabled={loading}
      >
        {loading ? "Registrando..." : "Registrarse"}
      </button>
    </form>
  );
}
